import React from 'react'
import content from 'pp-react-l10n'
import { Alert } from '@paypalcorp/pp-react'
import glamorous from 'glamorous'
import { isDw2Repaint } from '../../experiments/dw2Repaint'

let i18n = content('transfer/page/preview')

const AlertWrapper = glamorous.div({
  marginBottom: '1em',
})

/**
 * Cross Border Fee Mismatch Message component
 */
class XBFeeMismatch extends React.Component {
  render() {
    return (
      <>
        {isDw2Repaint() ? (
          <AlertWrapper>
            <Alert type="info">{i18n('xb.countryMismatch')}</Alert>
          </AlertWrapper>
        ) : (
          <div className="js-xbCountryMismatch xbCountryMismatch">
            <span
              className="icon icon-small icon-info-small xbCountryMismatch-icon"
              aria-hidden="true"
            />
            <p className="xbCountryMismatch-text">
              <span>{i18n('xb.countryMismatch')}</span>
            </p>
          </div>
        )}
      </>
    )
  }
}

export default XBFeeMismatch
